module.exports = __webpack_public_path__ + "img/20.1.bd7eebe0.jpg";